<template>

    <div class="c-form-duplicate">

        <c-input
            v-bind="$attrs"
            name="locationName"
            v-model="field.name"
            placeholder=""
            :horizontal="true"
            label="Locatie naam"
            />

        <c-input-element 
            :label="label" 
            :sublabel="sublabel" 
            :helptext="helptext" 
            :class="{ 'c-form-element--horizontal' : horizontal }"
            :name="$attrs.name">

            <div class="c-zipcode">

                <span class="input">
                    <input
                        class="c-form-element--small"
                        v-bind="$attrs"
                        name="zipcode"
                        data-error-message="Vul een correcte postcode en huisnummer in"
                        v-model="field.zipcode"
                        @change="lookup()"
                        @input="updateAddress"
                        />
                </span>

                <span class="input">
                    <input
                        class="c-form-element--tiny margin-l-16"
                        v-bind="$attrs"
                        name="number"
                        type="number"
                        v-model="field.number"
                        @input="updateAddress"
                        />
                </span>

                <span class="input">
                    <input
                        class="c-form-element--tiny margin-l-16"
                        v-bind="{...$attrs, required: undefined}"
                        name="addition"
                        v-model="field.addition"
                        @input="updateAddress"
                        placeholder="Toev."
                    />
                </span>

                <svg @click="deleteDeliveryAddress" class="c-form-duplicate__delete color-gray-600 margin-l-8" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11ZM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328ZM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z" id="trash"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#trash"/></svg>
            </div>

        </c-input-element>

        <div class="c-panel c-panel--tiny c-panel--gray-200 c-panel--address c-panel--no-shadow c-panel--no-radius margin-b-16 fs-xsmall c-zipcode-address__address-panel"  v-if="foundZipcode">
            <strong>{{sublabel}}</strong>
            <div>
                {{field.street}} {{field.number}}{{/^\d/.test(field.addition) ? '-' : ''}}{{field.addition}}<br/>
                {{field.zipcode}} {{field.city}}<br/>
            </div>
        </div>
        <div v-else>
            <div>
                <c-input
                    v-bind="$attrs"
                    name="street"
                    v-model="field.street"
                    @input="updateAddress"
                    placeholder="Straat"
                    :horizontal="true"
                    label="Straat"
                    />

                <c-input
                    v-bind="$attrs"
                    name="city"
                    v-model="field.city"
                    @input="updateAddress"
                    placeholder="Plaats"
                    :horizontal="true"
                    label="Plaats"
                />
            </div>
        </div>

    </div>
</template>

<script>
import Input from '@mixins/Input';
import Form from '@mixins/Form';

export default {
    mixins: [Input, Form],
    props: {
        zipcode: {
            type: String,
            default: ''
        },
        number: {
            default: ''
        },
        addition: {
            type: String,
            default: ''
        },
        street: {
            type: String,
            default: ''
        },
        city: {
            type: String,
            default: ''
        },
        locationName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            field: {
                zipcode: '',
                number: '',
                addition: '',
                street: '',
                city: '',
                name: ''
            },
            foundZipcode: true,
        }
    },
    watch: {
        zipcode(value) {
            this.field.zipcode = value;
        },
        number(value) {
            this.field.number = value;
        },
        addition(value) {
            this.field.addition = value;
        },
        street(value) {
            this.field.street = value;
        },
        city(value) {
            this.field.city = value;
        },
        locationName(value) {
            this.field.name = value;
        },
    },
    emits: ['delete-delivery-address', 'input'],
    methods: {
        deleteDeliveryAddress() {
            this.$emit('delete-delivery-address');
        },

        updateAddress() {
            this.$emit('input', this.field);
        },

        validZipcode() {
            let regex = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
            return regex.test(this.field.zipcode);
        },
        
        lookup() {
            this.foundZipcode = false;
            this.field.street = '';
            this.field.city = '';
            if ( this.validZipcode() ) {
                this.$xhr.get('/api/postal-code', {
                    postal_code: this.field.zipcode
                }).then( ( {result}) => {
                    this.field.street = result.street;
                    this.field.city = result.city;
                    this.updateAddress();
                    this.foundZipcode = true;
                }).catch( (e) => {
                });
            }
            else {
                this.field.street = '';
                this.field.city = '';
            }
        },
        getData(){
            let data = {
                zipcode: this.field.zipcode,
                number: this.field.number,
                addition: this.field.addition,
                street: this.field.street,
                city: this.field.city,
                name: this.field.name
            }
            return data;
        },
        clear()
        {
            this.field = {
                zipcode: '',
                number: '',
                addition: '',
                street: '',
                city: '',
                name: ''
            }
        }
    },
    mounted() {
        this.field.zipcode = this.zipcode;
        this.field.number = this.number;
        this.field.addition = this.addition;
        this.field.street = this.street;
        this.field.city = this.city;
        this.field.name = this.locationName;
        this.foundZipcode = true;
    }
}
</script>
<style scoped>
.c-zipcode {
    display: grid;
    grid-template-columns: repeat(4, auto);
    justify-content: left;
}
.c-zipcode:deep() > :not(.c-form__error-message) {
    grid-row: 1;
}
.c-zipcode:deep() > .c-form__error-message {
    grid-column: 1 / 5;
}
</style>